import {combineReducers} from "redux";

import {appIsInactiveReducer} from "@atg-mobileapp-shared/app-background";
import {isApp, isSportApp} from "@atg-shared/system";
import {rootReducer as big9} from "@atg-sport-shared/pool-data-access-root";
import {betOfferReducer} from "@atg-sport-shared/sportsbook-data-access-bet-offer";
import {betslipReducer} from "@atg-sport-shared/sportsbook-data-access-betslip";
import {crossPromotionsReducer} from "@atg-sport-shared/sportsbook-data-access-cross-promotions";
import {eventReducer} from "@atg-sport-shared/sportsbook-data-access-event";
import {fallbackHeroReducer} from "@atg-sport-shared/sportsbook-data-access-fallback-hero";
import {groupReducer} from "@atg-sport-shared/sportsbook-data-access-group";
import {heroReducer} from "@atg-sport-shared/sportsbook-data-access-hero";
import {
    kambiReducer,
    kambiClientReducer,
    kambiErrorsReducer,
} from "@atg-sport-shared/sportsbook-data-access-kambi";
import {kambiDetailsReducer} from "@atg-sport-shared/sportsbook-data-access-kambi-details";
import {loadingReducer} from "@atg-sport-shared/sportsbook-data-access-loading";
import {popularReducer} from "@atg-sport-shared/sportsbook-data-access-popular";
import {routeReducer} from "@atg-sport-shared/sportsbook-data-access-route";
import {searchReducer} from "@atg-sport-shared/sportsbook-data-access-search";
import {shortInfoReducer} from "@atg-sport-shared/sportsbook-data-access-short-info";
import {staticContentReducer} from "@atg-sport-shared/sportsbook-data-access-static-content";
import {statisticsReducer} from "@atg-sport-shared/sportsbook-data-access-statistics";

export const sportReducer = combineReducers({
    kambi: kambiReducer,
    kambiDetails: kambiDetailsReducer,
    kambiClient: kambiClientReducer,
    route: routeReducer,
    betslip: betslipReducer,
    loadingState: loadingReducer,
    groups: groupReducer,
    events: eventReducer,
    betOffers: betOfferReducer,
    // Web is not using the hero reducer anymore
    ...(isApp || isSportApp ? {hero: heroReducer} : {}),
    crossPromotions: crossPromotionsReducer,
    staticContent: staticContentReducer,
    search: searchReducer,
    popular: popularReducer,
    statistics: statisticsReducer,
    shortInfo: shortInfoReducer,
    selectedFallbackEvent: fallbackHeroReducer,
    kambiErrors: kambiErrorsReducer,
    big9,
    appIsInactive: appIsInactiveReducer,
});
